export const MCP_PROMPT_TEMPLATE_MARKER_PREFIX = '__mcp_prompt_template__:';

const PROMPT_TEMPLATE_MARKER_RE =
  /__mcp_prompt_template__:([0-9a-fA-F-]{36}|[^\s\n]+)/;

export function buildPromptTemplateMarker(id: string): string {
  return `${MCP_PROMPT_TEMPLATE_MARKER_PREFIX}${id}`;
}

/** User-visible Persian line + hidden machine marker for the backend. */
export function buildPromptTemplateUserMessage(template: {
  id: string;
  title: string;
}): string {
  const title = template.title.trim() || 'قالب پرامپت';
  return `اجرای قالب «${title}»\n${buildPromptTemplateMarker(template.id)}`;
}

export function parsePromptTemplateMarker(
  content: string | null | undefined
): string | null {
  if (!content) return null;
  const match = content.match(PROMPT_TEMPLATE_MARKER_RE);
  const id = match?.[1]?.trim();
  return id || null;
}

/** Strip machine marker so only the Persian label is shown in the UI. */
export function displayPromptTemplateUserMessage(
  content: string | null | undefined
): string {
  if (!content) return '';
  return content
    .replace(PROMPT_TEMPLATE_MARKER_RE, '')
    .replace(/\n{2,}/g, '\n')
    .trim();
}
